import React, { useEffect, useRef, useState } from 'react';
import { useTheme } from '@material-ui/core/styles';
import { Typography, Tooltip, IconButton, Snackbar, Box } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import { makeStyles } from '@material-ui/core/styles';
import CoreHttpHandler from 'http/services/CoreHttpHandler';
import ButtonOmni from 'allGlobalComponents/ButtonOmni';
import TableOmniNewAnimated from 'allGlobalComponents/TableOmniNewAnimated';
import ModalOmni from 'allGlobalComponents/ModalOmni';
import FormFieldOmni from 'allGlobalComponents/FormFieldOmni';
import DeleteConfirmationDialog from 'allGlobalComponents/DeleteConfirmationDoalog';
import { CSVLink } from 'react-csv';
import moment from 'moment';
import copy from 'copy-to-clipboard';
import AddIcon from '@mui/icons-material/Add';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import DownloadIcon from '@mui/icons-material/Download';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import EmailIcon from '@mui/icons-material/Email';
import SyncIcon from '@mui/icons-material/Sync';
import { globalDateFormat } from 'app/constants';
import { Icon } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
    headerRow: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginBottom: theme.spacing(3),
        flexWrap: 'wrap',
        gap: theme.spacing(2),
        width: '100%',
        boxSizing: 'border-box',
        [theme.breakpoints.down('xs')]: {
            flexDirection: 'column',
            alignItems: 'stretch'
        }
    },
    leftControls: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(2),
        flexWrap: 'wrap',
        [theme.breakpoints.down('xs')]: {
            width: '100%'
        }
    },
    rightControls: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1.5),
        flexWrap: 'wrap',
        [theme.breakpoints.down('xs')]: {
            width: '100%',
            justifyContent: 'flex-end'
        }
    },
    tableSection: {
        backgroundColor: theme.palette.background.paper,
        borderRadius: 12,
        overflow: 'hidden',
        width: '100%',
        boxSizing: 'border-box'
    },
    snoCell: {
        fontWeight: 500,
        color: theme.palette.text.secondary
    },
    formContainer: {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(2),
        padding: theme.spacing(2)
    },
    fieldRow: {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(0.5)
    },
    fieldLabel: {
        fontSize: '1.2rem',
        color: theme.palette.text.secondary,
        fontWeight: 500
    },
    uploadSection: {
        marginTop: theme.spacing(2),
        padding: theme.spacing(3),
        border: `2px dashed ${theme.palette.divider}`,
        borderRadius: 12,
        textAlign: 'center',
        backgroundColor: theme.palette.type === 'dark' ? 'rgba(255,255,255,0.02)' : 'rgba(0,0,0,0.02)',
        cursor: 'pointer',
        transition: 'all 0.2s ease',
        '&:hover': {
            borderColor: theme.palette.primary.main,
            backgroundColor: theme.palette.type === 'dark' ? 'rgba(59, 130, 246, 0.1)' : 'rgba(25, 118, 210, 0.05)'
        }
    },
    uploadIcon: {
        fontSize: 48,
        color: theme.palette.text.secondary,
        marginBottom: theme.spacing(1)
    },
    uploadText: {
        color: theme.palette.text.secondary,
        fontSize: 14
    },
    uploadHint: {
        color: theme.palette.text.disabled,
        fontSize: 12,
        marginTop: theme.spacing(0.5)
    },
    fileName: {
        marginTop: theme.spacing(1),
        padding: theme.spacing(1, 2),
        backgroundColor: theme.palette.type === 'dark' ? 'rgba(59, 130, 246, 0.2)' : 'rgba(25, 118, 210, 0.1)',
        borderRadius: 8,
        display: 'inline-block',
        fontSize: 13,
        color: theme.palette.primary.main
    },
    viewSection: {
        marginBottom: theme.spacing(2)
    },
    viewLabel: {
        fontSize: 12,
        fontWeight: 600,
        color: theme.palette.text.secondary,
        marginBottom: theme.spacing(0.5),
        textTransform: 'uppercase'
    },
    viewValue: {
        fontSize: 14,
        color: theme.palette.text.primary,
        padding: theme.spacing(1.5),
        backgroundColor: theme.palette.type === 'dark' ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.03)',
        borderRadius: 8,
        wordBreak: 'break-word'
    },
    emailCountBadge: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: theme.spacing(0.5),
        padding: '4px 10px',
        borderRadius: 16,
        fontSize: 12,
        fontWeight: 600,
        backgroundColor: theme.palette.type === 'dark' ? 'rgba(59, 130, 246, 0.2)' : 'rgba(59, 130, 246, 0.1)',
        color: theme.palette.type === 'dark' ? '#60A5FA' : '#2563EB'
    },
    actionsRow: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginTop: theme.spacing(2),
        paddingTop: theme.spacing(2),
        borderTop: `1px solid ${theme.palette.divider}`
    },
    downloadLink: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(0.5),
        color: theme.palette.type === 'dark' ? '#FFFFFF' : theme.palette.primary.main,
        cursor: 'pointer',
        fontSize: 14,
        fontWeight: 500,
        background: 'none',
        border: 'none',
        padding: 0,
        textDecoration: 'none',
        '&:hover': {
            textDecoration: 'underline',
            color: theme.palette.type === 'dark' ? '#E5E7EB' : theme.palette.primary.dark
        }
    },
    downloadIcon: {
        fontSize: 18,
        color: theme.palette.type === 'dark' ? '#FFFFFF' : theme.palette.primary.main
    },
    refreshButton: {
        padding: 8,
        color: theme.palette.type === 'dark' ? '#FFFFFF' : '#000000',
        '&:hover': {
            backgroundColor: theme.palette.action.hover
        },
        '& .MuiSvgIcon-root': {
            fontSize: 24,
            fontWeight: 'bold'
        }
    },
    // Add after refreshButton style in useStyles
    dragActive: {
        borderColor: theme.palette.primary.main,
        backgroundColor: theme.palette.type === 'dark' ? 'rgba(59, 130, 246, 0.15)' : 'rgba(25, 118, 210, 0.08)',
        transform: 'scale(1.01)',
    },
    uploadProgress: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: theme.spacing(1),
        marginTop: theme.spacing(1),
    },
    fileInfo: {
        marginTop: theme.spacing(1.5),
        padding: theme.spacing(1.5, 2),
        backgroundColor: theme.palette.type === 'dark' ? 'rgba(59, 130, 246, 0.15)' : 'rgba(25, 118, 210, 0.08)',
        borderRadius: 10,
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1.5),
        border: `1px solid ${theme.palette.type === 'dark' ? 'rgba(59, 130, 246, 0.3)' : 'rgba(25, 118, 210, 0.2)'}`,
    },
    fileIcon: {
        fontSize: 20,
        color: theme.palette.primary.main,
    },
    fileDetails: {
        flex: 1,
        overflow: 'hidden',
    },
    fileNameText: {
        fontSize: 13,
        fontWeight: 600,
        color: theme.palette.text.primary,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },
    fileSize: {
        fontSize: 11,
        color: theme.palette.text.secondary,
    },
    removeFile: {
        padding: 4,
        color: theme.palette.text.secondary,
        '&:hover': {
            color: theme.palette.error.main,
            backgroundColor: theme.palette.type === 'dark' ? 'rgba(239, 68, 68, 0.1)' : 'rgba(239, 68, 68, 0.08)',
        },
    },
    uploadCheckIcon: {
        fontSize: 20,
        color: theme.palette.success.main,
    },
    formTitle: {
        fontSize: 13,
        color: theme.palette.text.secondary,
        marginBottom: theme.spacing(2),
    },
    requiredStar: {
        color: theme.palette.error.main,
    },
    sampleDownloadRow: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        marginTop: theme.spacing(1),
    },
    sampleLink: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: 4,
        fontSize: 12,
        color: theme.palette.primary.main,
        cursor: 'pointer',
        fontWeight: 500,
        background: 'none',
        border: 'none',
        padding: '4px 0',
        '&:hover': {
            textDecoration: 'underline',
        },
    },
}));

function ContactsTab({ userData = null }) {
    const theme = useTheme();
    const classes = useStyles();
    const csvLinkRef = useRef(null);

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [totalItems, setTotalItems] = useState(0);

    const [dateRange, setDateRange] = useState({
        startDate: moment().startOf('day'),
        endDate: moment().endOf('day')
    });

    const [currentParams, setCurrentParams] = useState({
        page: 0,
        limit: 10
    });

    const [createModalOpen, setCreateModalOpen] = useState(false);
    const [editModalOpen, setEditModalOpen] = useState(false);
    const [viewModalOpen, setViewModalOpen] = useState(false);
    const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
    const [dragActive, setDragActive] = useState(false);
    const [formData, setFormData] = useState({ name: '' });
    const [uploadedFile, setUploadedFile] = useState(null);
    const [uploading, setUploading] = useState(false);
    const [uploadedFileUrl, setUploadedFileUrl] = useState(null);
    const [editingContact, setEditingContact] = useState(null);
    const [viewingContact, setViewingContact] = useState(null);
    const [deletingContact, setDeletingContact] = useState(null);

    const [isCreating, setIsCreating] = useState(false);
    const [isUpdating, setIsUpdating] = useState(false);
    const [isDeleting, setIsDeleting] = useState(false);

    const [snackbar, setSnackbar] = useState({
        open: false,
        message: '',
        severity: 'success'
    });

    const [exportData, setExportData] = useState([]);

    const handleDrag = (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (e.type === 'dragenter' || e.type === 'dragover') {
            setDragActive(true);
        } else if (e.type === 'dragleave') {
            // Only set inactive if leaving the drop zone (not entering a child)
            const rect = e.currentTarget.getBoundingClientRect();
            const x = e.clientX;
            const y = e.clientY;
            if (x < rect.left || x > rect.right || y < rect.top || y > rect.bottom) {
                setDragActive(false);
            }
        }
    };
    const processFile = (file) => {
        if (!file) return;

        const fileName = file.name.toLowerCase();
        if (!fileName.endsWith('.csv')) {
            setUploadedFile(null);
            setUploadedFileUrl(null);
            showSnackbar('Invalid file type. Please upload a CSV file only.', 'error');
            return;
        }

        const sizeLimitInBytes = 10000000;
        if (file.size >= sizeLimitInBytes) {
            setUploadedFile(null);
            setUploadedFileUrl(null);
            showSnackbar('File Size Limit Exceeded. Please select a file less than 10 MB', 'error');
            return;
        }

        const reader = new FileReader();
        reader.onload = (event) => {
            const text = event.target.result;
            const lines = text.split('\n');

            if (lines.length === 0 || !lines[0].trim()) {
                setUploadedFile(null);
                setUploadedFileUrl(null);
                showSnackbar('File is empty.', 'error');
                return;
            }

            const headers = lines[0].toLowerCase().split(',').map(h => h.trim().replace(/["']/g, ''));
            const hasEmailColumn = headers.some(header => header === 'email');

            if (!hasEmailColumn) {
                setUploadedFile(null);
                setUploadedFileUrl(null);
                showSnackbar('CSV file must contain an "email" column. Please check your file headers.', 'error');
                return;
            }

            setUploadedFile(file);
            setUploading(true);

            const fd = new FormData();
            const cleanFileName = file.name.replace(/\s/g, '');
            const uploadFileName = `${new Date().getTime()}_${cleanFileName}`;

            fd.append('file', file, uploadFileName);
            fd.append('template_upload', 'true');
            if (userData?.id) {
                fd.append('clientId', userData.id);
            }

            CoreHttpHandler.request(
                'content',
                'upload',
                { params: fd },
                response => {
                    const res = response.data.data;
                    setUploadedFileUrl(res.link);
                    setUploading(false);
                    showSnackbar('File uploaded successfully.', 'success');
                },
                error => {
                    setUploading(false);
                    setUploadedFile(null);
                    setUploadedFileUrl(null);
                    showSnackbar(
                        error?.response?.data?.data?.error?.error_data?.details ||
                        error?.response?.data?.message ||
                        'File upload failed',
                        'error'
                    );
                }
            );
        };
        reader.onerror = () => {
            setUploadedFile(null);
            setUploadedFileUrl(null);
            showSnackbar('Failed to read file.', 'error');
        };
        reader.readAsText(file);
    };
    const handleDrop = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setDragActive(false);
        if (e.dataTransfer.files && e.dataTransfer.files[0]) {
            const file = e.dataTransfer.files[0];
            processFile(file);
        }
    };

    const handleRemoveFile = () => {
        setUploadedFile(null);
        setUploadedFileUrl(null);
        const input = document.getElementById('csv-upload-input');
        if (input) input.value = '';
    };

    const formatFileSize = (bytes) => {
        if (bytes < 1024) return bytes + ' B';
        if (bytes < 1048576) return (bytes / 1024).toFixed(1) + ' KB';
        return (bytes / 1048576).toFixed(1) + ' MB';
    };
    const fetchContacts = () => {
        setLoading(true);
        const apiPayload = {
            page: currentParams.page,
            limit: currentParams.limit,
            channel_type: 'email',
            recipients_type: 'emails',
        }
        if (userData?.id) {
            apiPayload.clientId = userData?.id;
        }

        CoreHttpHandler.request(
            'templateMessagesMFMS',
            'fetch_recipients',
            apiPayload,
            response => {
                const contacts = response.data?.data?.data || [];
                const total = response.data?.data?.totalItems || contacts.length || 0;
                setData(Array.isArray(contacts) ? contacts : []);
                setTotalItems(total);
                setLoading(false);
            },
            error => {
                console.error('Error fetching contacts:', error);
                setData([]);
                setTotalItems(0);
                setLoading(false);
                showSnackbar('Failed to fetch contacts', 'error');
            }
        );
    };

    useEffect(() => {
        fetchContacts();
    }, [currentParams, dateRange]);

    const showSnackbar = (message, severity = 'success') => {
        setSnackbar({ open: true, message, severity });
    };

    const handleSnackbarClose = () => {
        setSnackbar(prev => ({ ...prev, open: false }));
    };
    // Validate file type and check for email column
    const validateFile = (file) => {
        return new Promise((resolve, reject) => {
            // Check file extension
            const fileName = file.name.toLowerCase();
            const validExtensions = ['.csv', '.xlsx', '.xls'];
            const hasValidExtension = validExtensions.some(ext => fileName.endsWith(ext));

            if (!hasValidExtension) {
                reject('Invalid file type. Please upload a CSV or Excel file (.csv, .xlsx, .xls)');
                return;
            }

            // For CSV files, check for email column
            if (fileName.endsWith('.csv')) {
                const reader = new FileReader();
                reader.onload = (e) => {
                    const text = e.target.result;
                    const lines = text.split('\n');
                    if (lines.length === 0) {
                        reject('File is empty');
                        return;
                    }

                    // Get header row (first line)
                    const headers = lines[0].toLowerCase().split(',').map(h => h.trim().replace(/["']/g, ''));

                    // Check if 'email' column exists
                    const hasEmailColumn = headers.some(header =>
                        header === 'email'
                    );

                    if (!hasEmailColumn) {
                        reject('CSV file must contain an "email" column. Please check your file headers.');
                        return;
                    }

                    resolve(true);
                };
                reader.onerror = () => {
                    reject('Failed to read file');
                };
                reader.readAsText(file);
            }
            // For Excel files, check for email column
            else if (fileName.endsWith('.xlsx') || fileName.endsWith('.xls')) {
                // For Excel files, we need to use a library like SheetJS (xlsx)
                // If you have xlsx library installed:
                import('xlsx').then((XLSX) => {
                    const reader = new FileReader();
                    reader.onload = (e) => {
                        try {
                            const data = new Uint8Array(e.target.result);
                            const workbook = XLSX.read(data, { type: 'array' });
                            const firstSheetName = workbook.SheetNames[0];
                            const worksheet = workbook.Sheets[firstSheetName];
                            const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

                            if (jsonData.length === 0) {
                                reject('File is empty');
                                return;
                            }

                            // Get header row
                            const headers = jsonData[0].map(h => String(h).toLowerCase().trim());

                            // Check if 'email' column exists
                            const hasEmailColumn = headers.some(header =>
                                header === 'email'
                            );

                            if (!hasEmailColumn) {
                                reject('Excel file must contain an "email" column. Please check your file headers.');
                                return;
                            }

                            resolve(true);
                        } catch (error) {
                            reject('Failed to parse Excel file');
                        }
                    };
                    reader.onerror = () => {
                        reject('Failed to read file');
                    };
                    reader.readAsArrayBuffer(file);
                }).catch(() => {
                    // If xlsx library is not available, just check extension
                    resolve(true);
                });
            }
        });
    };

    const handlePaginationChange = (page, limit) => {
        setCurrentParams({ page, limit });
    };

    const handleRefresh = () => {
        fetchContacts();
    };

    const handleCreate = () => {
        setFormData({ name: '' });
        setUploadedFile(null);
        setUploadedFileUrl(null);
        setCreateModalOpen(true);
    };
    const handleFileChange = (e) => {
        const file = e.target.files[0];
        const inputElement = e.target;

        if (!file) return;

        // Check file extension
        const fileName = file.name.toLowerCase();
        if (!fileName.endsWith('.csv')) {
            setUploadedFile(null);
            setUploadedFileUrl(null);
            inputElement.value = '';
            showSnackbar('Invalid file type. Please upload a CSV file only.', 'error');
            return;
        }

        // Check file size (10MB limit)
        const sizeLimitInBytes = 10000000;
        if (file.size >= sizeLimitInBytes) {
            setUploadedFile(null);
            setUploadedFileUrl(null);
            inputElement.value = '';
            showSnackbar('File Size Limit Exceeded. Please select a file less than 10 MB', 'error');
            return;
        }

        // Read and validate CSV for email column
        const reader = new FileReader();
        reader.onload = (event) => {
            const text = event.target.result;
            const lines = text.split('\n');

            if (lines.length === 0 || !lines[0].trim()) {
                setUploadedFile(null);
                setUploadedFileUrl(null);
                inputElement.value = '';
                showSnackbar('File is empty.', 'error');
                return;
            }

            // Get header row (first line)
            const headers = lines[0].toLowerCase().split(',').map(h => h.trim().replace(/["']/g, ''));

            // Check if 'email' column exists
            const hasEmailColumn = headers.some(header => header === 'email');

            if (!hasEmailColumn) {
                setUploadedFile(null);
                setUploadedFileUrl(null);
                inputElement.value = '';
                showSnackbar('CSV file must contain an "email" column. Please check your file headers.', 'error');
                return;
            }

            // File is valid, now upload it
            setUploadedFile(file);
            setUploading(true);

            const formData = new FormData();
            const cleanFileName = file.name.replace(/\s/g, '');
            const uploadFileName = `${new Date().getTime()}_${cleanFileName}`;

            formData.append('file', file, uploadFileName);
            formData.append('template_upload', 'true');
            if (userData?.id) {
                formData.append('clientId', userData.id);
            }

            CoreHttpHandler.request(
                'content',
                'upload',
                { params: formData },
                response => {
                    const res = response.data.data;
                    setUploadedFileUrl(res.link);
                    setUploading(false);
                    showSnackbar('File uploaded successfully.', 'success');
                },
                error => {
                    setUploading(false);
                    setUploadedFile(null);
                    setUploadedFileUrl(null);
                    showSnackbar(
                        error?.response?.data?.data?.error?.error_data?.details ||
                        error?.response?.data?.message ||
                        'File upload failed',
                        'error'
                    );
                }
            );
        };
        reader.onerror = () => {
            setUploadedFile(null);
            setUploadedFileUrl(null);
            inputElement.value = '';
            showSnackbar('Failed to read file.', 'error');
        };
        reader.readAsText(file);
    };

    const handleDownloadDemoCSV = (e) => {
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }
        const csvContent = 'email,your_column_1,your_column_2\njohn@example.com,value1,value2\n';
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const blobUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = blobUrl;
        link.download = 'recipients_sample.csv';
        link.style.display = 'none';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(blobUrl);
    };

    const handleCreateConfirm = () => {
        if (!formData.name.trim()) {
            showSnackbar('Please enter contact list name', 'error');
            return;
        }
        if (!uploadedFile || !uploadedFileUrl) {
            showSnackbar('Please upload a CSV file', 'error');
            return;
        }
        setIsCreating(true);

        const apiPayload = {
            name: formData.name.trim(),
            recipients_type: "emails",
            file: uploadedFileUrl,
            channel_type: "email"
        };
        if (userData?.id) {
            apiPayload.clientId = userData.id;
        }

        CoreHttpHandler.request(
            'emailCampaign',
            'createEmailRecipients',
            apiPayload,
            response => {
                setIsCreating(false);
                if (response.data?.code === 200 || response.data?.success) {
                    showSnackbar('Contact list created successfully', 'success');
                    setCreateModalOpen(false);
                    setUploadedFileUrl(null);
                    fetchContacts();
                } else {
                    showSnackbar(response.data?.message || 'Failed to create contact list', 'error');
                }
            },
            error => {
                setIsCreating(false);
                const errorMessage = error.response?.data?.message || 'Failed to create contact list';
                showSnackbar(errorMessage, 'error');
            }
        );
    };

    const handleViewClick = (contact) => {
        setViewingContact(contact);
        setViewModalOpen(true);
    };

    const handleEditClick = (contact) => {
        setEditingContact(contact);
        setFormData({ name: contact.name || '' });
        setUploadedFile(null);
        setEditModalOpen(true);
    };

    const handleEditConfirm = () => {
        if (!formData.name.trim()) {
            showSnackbar('Please enter contact list name', 'error');
            return;
        }
        setIsUpdating(true);
        const apiPayload = {
            id: editingContact.id,
            name: formData.name.trim(),
        };
        if (userData?.id) {
            apiPayload.clientId = userData?.id;
        }

        CoreHttpHandler.request(
            'templateMessagesMFMS',
            'update_recipients',
            apiPayload,
            response => {
                setIsUpdating(false);
                if (response.data?.code === 200 || response.data?.success) {
                    showSnackbar('Contact list updated successfully', 'success');
                    setEditModalOpen(false);
                    setEditingContact(null);
                    fetchContacts();
                } else {
                    showSnackbar(response.data?.message || 'Failed to update contact list', 'error');
                }
            },
            error => {
                setIsUpdating(false);
                const errorMessage = error.response?.data?.message || 'Failed to update contact list';
                showSnackbar(errorMessage, 'error');
            }
        );
    };

    const handleDeleteClick = (contact) => {
        setDeletingContact(contact);
        setDeleteDialogOpen(true);
    };

    const handleDeleteConfirm = () => {
        setIsDeleting(true);
        const apiPayload = {
            recipients_id: deletingContact.id,
            type: "emails",
            check: "all"
        };
        if (userData?.id) {
            apiPayload.clientId = userData?.id;
        }

        CoreHttpHandler.request(
            'emailCampaign',
            'deleteRecipients',
            apiPayload,
            response => {
                setIsDeleting(false);
                if (response.data?.code === 200 || response.data?.success) {
                    showSnackbar('Contact list deleted successfully', 'success');
                    setDeleteDialogOpen(false);
                    setDeletingContact(null);
                    fetchContacts();
                }
            },
            error => {
                setIsDeleting(false);
                showSnackbar('Failed to delete contact list', 'error');
            }
        );
    };

    const handleNameChange = (e) => {
        setFormData(prev => ({ ...prev, name: e.target.value }));
    };

    const getEmailCount = (row) => {
        const count = row?.records_count ?? "-";
        if (count === null || count === undefined || count === '') {
            return '-';
        }
        return count;
    };

    const headCells = [
        { id: 'id', numeric: false, disablePadding: false, label: 'ID' },
        { id: 'name', numeric: false, disablePadding: false, label: 'Name', msg: true, truncateLength: 40 },
        {
            id: 'records_count',
            numeric: false,
            disablePadding: false,
            label: 'No of Emails',
            customRow: row => {
                const count = getEmailCount(row);
                return (
                    <span className={count !== '-' ? classes.emailCountBadge : ''}>
                        {count !== '-' && <EmailIcon style={{ fontSize: 14 }} />}
                        {count}
                    </span>
                );
            }
        },
        { id: 'dt', numeric: false, disablePadding: false, label: 'Date', dt: true },
        {
            id: 'delete',
            numeric: false,
            disablePadding: false,
            label: 'Delete',
        }
    ];

    const renderCreateFormContent = () => (
        <div className={classes.formContainer}>
            <Typography className={classes.formTitle}>
                Create a new contact list by uploading a CSV file containing email addresses.
            </Typography>
            <div className={classes.fieldRow}>
                <Typography className={classes.fieldLabel}>
                    List Name <span className={classes.requiredStar}>*</span>
                </Typography>
                <FormFieldOmni
                    variant="outlined"
                    value={formData.name}
                    onChange={handleNameChange}
                    size="small"
                    fullWidth
                    placeholder="Enter contact list name"
                />
            </div>
            <div className={classes.fieldRow}>
                <Typography className={classes.fieldLabel}>
                    Upload CSV File <span className={classes.requiredStar}>*</span>
                </Typography>
                <input
                    type="file"
                    accept=".csv"
                    style={{ display: 'none' }}
                    id="csv-upload-input"
                    onChange={handleFileChange}
                />
                {!uploadedFile ? (
                    <div
                        className={`${classes.uploadSection} ${dragActive ? classes.dragActive : ''}`}
                        onDragEnter={handleDrag}
                        onDragLeave={handleDrag}
                        onDragOver={handleDrag}
                        onDrop={handleDrop}
                        onClick={() => document.getElementById('csv-upload-input').click()}
                    >
                        <CloudUploadIcon className={classes.uploadIcon} />
                        <Typography className={classes.uploadText}>
                            {dragActive ? 'Drop your file here' : 'Click to upload CSV file'}
                        </Typography>
                        <Typography className={classes.uploadHint}>
                            or drag & drop • CSV files only • Max 10MB
                        </Typography>
                    </div>
                ) : (
                    <div className={classes.fileInfo}>
                        {uploading ? (
                            <SyncIcon className={classes.fileIcon} style={{ animation: 'spin 1s linear infinite' }} />
                        ) : uploadedFileUrl ? (
                            <Icon className={classes.uploadCheckIcon}>check_circle</Icon>
                        ) : (
                            <Icon className={classes.fileIcon}>description</Icon>
                        )}
                        <div className={classes.fileDetails}>
                            <Typography className={classes.fileNameText}>
                                {uploadedFile.name}
                            </Typography>
                            <Typography className={classes.fileSize}>
                                {formatFileSize(uploadedFile.size)}
                                {uploading && ' • Uploading...'}
                                {!uploading && uploadedFileUrl && ' • Ready'}
                            </Typography>
                        </div>
                        {!uploading && (
                            <IconButton className={classes.removeFile} size="small" onClick={handleRemoveFile}>
                                <Icon style={{ fontSize: 18 }}>close</Icon>
                            </IconButton>
                        )}
                    </div>
                )}
            </div>
            <div className={classes.sampleDownloadRow}>
                <button className={classes.sampleLink} onClick={handleDownloadDemoCSV}>
                    <DownloadIcon style={{ fontSize: 14 }} />
                    Download sample CSV
                </button>
            </div>
        </div>
    );

    const renderEditFormContent = () => (
        <div className={classes.formContainer}>
            <div className={classes.fieldRow}>
                <Typography className={classes.fieldLabel}>List Name *</Typography>
                <FormFieldOmni
                    variant="outlined"
                    value={formData.name}
                    onChange={handleNameChange}
                    size="small"
                    fullWidth
                    placeholder="Enter contact list name"
                />
            </div>
        </div>
    );

    const renderViewContent = () => (
        <div className={classes.formContainer}>
            <div className={classes.viewSection}>
                <Typography className={classes.viewLabel}>ID</Typography>
                <div className={classes.viewValue}>{viewingContact?.id || '-'}</div>
            </div>
            <div className={classes.viewSection}>
                <Typography className={classes.viewLabel}>Name</Typography>
                <div className={classes.viewValue}>{viewingContact?.name || '-'}</div>
            </div>
            <div className={classes.viewSection}>
                <Typography className={classes.viewLabel}>No of Emails</Typography>
                <div className={classes.viewValue}>{getEmailCount(viewingContact) || '-'}</div>
            </div>
            <div className={classes.viewSection}>
                <Typography className={classes.viewLabel}>Created Date</Typography>
                <div className={classes.viewValue}>{viewingContact?.dt ? moment(viewingContact.dt).format(globalDateFormat) : '-'}</div>
            </div>
        </div>
    );

    const csvFilename = `email_contacts_${dateRange.startDate.format('YYYY-MM-DD')}_to_${dateRange.endDate.format('YYYY-MM-DD')}_${moment().format('YYYY-MM-DD')}.csv`;

    return (
        <>
            <div className={classes.headerRow}>
                <div className={classes.leftControls}></div>
                <div className={classes.rightControls}>
                    <Tooltip title="Refresh" arrow>
                        <IconButton className={classes.refreshButton} onClick={handleRefresh} disabled={loading}>
                            <SyncIcon />
                        </IconButton>
                    </Tooltip>
                    <ButtonOmni onClick={handleCreate} label={
                        <Box display="flex" alignItems="center" gap={1}>
                            <Icon>person_add</Icon>
                            <Typography style={{ marginLeft: '10px' }}>
                                Add Recipient
                            </Typography>
                        </Box>
                    } size="small" />
                </div>
            </div>

            <div className={classes.tableSection}>
                <TableOmniNewAnimated
                    onEditClick={handleEditClick}
                    onDeleteClick={handleDeleteClick}
                    onViewClick={handleViewClick}
                    headCells={headCells}
                    rows={data}
                    loading={loading}
                    totalItems={totalItems}
                    perPageRows={currentParams.limit}
                    curPage={currentParams.page}
                    setCurrentParams={setCurrentParams}
                    rowsPerPageOptions={[10, 25, 50, 100]}
                    emptyMessage="No Contact Lists Found"
                />
            </div>

            <ModalOmni
                open={createModalOpen}
                handleClose={() => setCreateModalOpen(false)}
                title="Add Contact List"
                content={renderCreateFormContent()}
                customWidth={500}
                disableBackdropClick={true}
                disableEscapeKeyDown={true}
                actions={
                    <>
                        <ButtonOmni onClick={() => setCreateModalOpen(false)} variant="outlined" label="Cancel" size="small" disabled={isCreating} />
                        <ButtonOmni onClick={handleCreateConfirm} label={isCreating ? 'Creating...' : 'Create'} size="small" loading={isCreating} disabled={isCreating || uploading || !formData.name.trim() || !uploadedFile || !uploadedFileUrl} />
                    </>
                }
            />

            <ModalOmni
                open={editModalOpen}
                handleClose={() => { setEditModalOpen(false); setEditingContact(null); }}
                title="Edit Contact List"
                content={renderEditFormContent()}
                customWidth={500}
                disableBackdropClick={true}
                disableEscapeKeyDown={true}
                actions={
                    <>
                        <ButtonOmni onClick={() => { setEditModalOpen(false); setEditingContact(null); }} variant="outlined" label="Cancel" size="small" disabled={isUpdating} />
                        <ButtonOmni onClick={handleEditConfirm} label={isUpdating ? 'Updating...' : 'Update'} size="small" loading={isUpdating} disabled={isUpdating || !formData.name.trim()} />
                    </>
                }
            />

            <ModalOmni
                open={viewModalOpen}
                handleClose={() => { setViewModalOpen(false); setViewingContact(null); }}
                title="Contact List Details"
                content={renderViewContent()}
                customWidth={500}
                disableBackdropClick={true}
                disableEscapeKeyDown={true}
                actions={<ButtonOmni onClick={() => { setViewModalOpen(false); setViewingContact(null); }} variant="outlined" label="Close" size="small" />}
            />

            <DeleteConfirmationDialog
                open={deleteDialogOpen}
                onClose={() => { setDeleteDialogOpen(false); setDeletingContact(null); }}
                onConfirm={handleDeleteConfirm}
                title="Delete Contact List"
                message={`Are you sure you want to delete "${deletingContact?.name}"? This action cannot be undone.`}
                confirmLabel="Delete"
                cancelLabel="Cancel"
                loading={isDeleting}
            />

            <Snackbar open={snackbar.open} autoHideDuration={4000} onClose={handleSnackbarClose} anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}>
                <Alert onClose={handleSnackbarClose} severity={snackbar.severity} variant="filled">{snackbar.message}</Alert>
            </Snackbar>
        </>
    );
}

export default ContactsTab;